
            const data = {"name":"succes","data":{"width":"72","height":"72","viewBox":"0 0 72 72","data":"<path pid=\"0\" d=\"M36 4a32 32 0 1 0 0 64 32 32 0 0 0 0-64Zm20.9 21.26L30.62 51.52 15.1 36a2.829 2.829 0 0 1 4-4l11.56 11.56L52.94 21.3a2.83 2.83 0 0 1 4 4l-.04-.04Z\" _fill=\"#31B049\"/>","originalColors":[{"type":"fill","color":"#31B049"}],"stopColors":[]}}
        
                    module.exports = data
                    